import { QuestionCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import CustModal from "./ShowModal";


function QuestionHelp(props) {
    const {
        style,
        children
    } = props;
    const [modalVisible, setModalVisible]=useState(false);
    const showChildren=()=>{
        setModalVisible(true)
    }
    return (

        <div style={{ position: 'absolute', right: '10px', top: '10px', background: '#fff', padding:'10px', zIndex: '1000', ...style }}>
            <QuestionCircleOutlined onClick={showChildren} />

            <CustModal
            title={'使用帮助'}
            open={modalVisible}
            onOk={() => setModalVisible(false)}
            onCancel={() => setModalVisible(false)}
            width={'80vw'}>
                {children}
            </CustModal>
        </div>
    )
}
export default QuestionHelp;